var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy07(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2484_4215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75002 1.66896C8.18748 1.67658 7.84977 1.70915 7.5767 1.84828C7.2631 2.00807 7.00813 2.26304 6.84834 2.57664C6.70921 2.84971 6.67664 3.18742 6.66902 3.74996M16.25 1.66896C16.8126 1.67658 17.1503 1.70915 17.4233 1.84828C17.7369 2.00807 17.9919 2.26304 18.1517 2.57664C18.2908 2.84971 18.3234 3.18741 18.331 3.74995M18.331 11.25C18.3234 11.8125 18.2908 12.1502 18.1517 12.4233C17.9919 12.7369 17.7369 12.9918 17.4233 13.1516C17.1503 13.2908 16.8126 13.3233 16.25 13.331M18.3334 6.66662V8.33329M11.6667 1.66663H13.3333M4.33335 18.3333H10.6667C11.6001 18.3333 12.0668 18.3333 12.4233 18.1516C12.7369 17.9918 12.9919 17.7369 13.1517 17.4233C13.3334 17.0668 13.3334 16.6 13.3334 15.6666V9.33329C13.3334 8.39987 13.3334 7.93316 13.1517 7.57664C12.9919 7.26304 12.7369 7.00807 12.4233 6.84828C12.0668 6.66663 11.6001 6.66663 10.6667 6.66663H4.33335C3.39993 6.66663 2.93322 6.66663 2.5767 6.84828C2.2631 7.00807 2.00813 7.26304 1.84834 7.57664C1.66669 7.93316 1.66669 8.39987 1.66669 9.33329V15.6666C1.66669 16.6 1.66669 17.0668 1.84834 17.4233C2.00813 17.7369 2.2631 17.9918 2.5767 18.1516C2.93322 18.3333 3.39993 18.3333 4.33335 18.3333Z",
    stroke: "#CECFD2",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2484_4215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy07);
export default __webpack_public_path__ + "static/media/copy-07.41d9197a5957d707aa9466d9e37a33c5.svg";
export { ForwardRef as ReactComponent };